export function eventAdd(event) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(event)
  })
}

export function eventAddRoom(event_id, room_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${event_id}/room`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({ room_id })
  })
}

export function eventRemoveRoom(event_id, room_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${event_id}/remove-room`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({ room_id })
  })
}

export function eventGetAll() {
  return fetch(`${process.env.REACT_APP_API_HOST}/event`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function eventGetOne(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function eventUpdate(_id, event) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(event)
  })
}

export function eventUpdateEmailContent(_id, event) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(event)
  })
}

export function eventUpdateModeratorEmailContent(_id, event) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}/moderatorEmailContent`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(event)
  })
}

export function eventDelete(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function eventClone(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function eventSendEmail(_id, speakerIDs, emailObject) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}/sendEmail`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({ speakers: speakerIDs, email: emailObject })
  })
}

export function eventSendModeratorEmail(_id, speakerIDs, emailObject) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${_id}/sendModeratorEmail`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({ speakers: speakerIDs, email: emailObject })
  })
}

export function eventGetOneAsPublic(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/public-event/${_id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}

export function publicEventGetOne(eventPresentation) {
  return fetch(`${process.env.REACT_APP_API_HOST}/public-event/${eventPresentation}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}

export function passwordEventGetOne(eventPresentation) {
  return fetch(`${process.env.REACT_APP_API_HOST}/password-event/${eventPresentation}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}

export function getSpeakerPresentations(eventId, speakerId) {
  return fetch(`${process.env.REACT_APP_API_HOST}/speaker-event/${eventId}/${speakerId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}

export function getAllPublicEvents() {
  return fetch(`${process.env.REACT_APP_API_HOST}/events`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}
